import SingleCart from "./SingleCart";
import { useSelector } from "react-redux";
import styles from "./MyAccount.module.css";

const FavoritesSection = () => {
  const loggedUser = useSelector((state) => state.loggedUser);

  return (
    <div className={styles.cartOuter}>
      {loggedUser.favorites && loggedUser.favorites.length > 0 ? (
        loggedUser.favorites.map((item, index) => (
          <SingleCart key={index} img={item} />
        ))
      ) : (
        <div className={`${styles.nothingBox} py-4`}>
          You have nothing in your favorites.
        </div>
      )}
    </div>
  );
};

export default FavoritesSection;
